import eventsLabel from '../../mocks/events/eventsLabel.json';

export const getLabelTranslate = (key, type = 'events') => {
  if(type === 'events') {
    const event = eventsLabel.filter(event => event.value === key)[0];
    return event && event.label ? event.label : key;
  }
  
  return key;
}